import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vertical-bar-chart-icon",
  "use": "vertical-bar-chart-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"vertical-bar-chart-icon\">\n  <path fill=\"#677078\" d=\"M9,17 L7,17 L7,10 L9,10 L9,17 Z M13,17 L11,17 L11,7 L13,7 L13,17 Z M17,17 L15,17 L15,13 L17,13 L17,17 Z M19.5,19.1 L4.5,19.1 L4.5,5 L19.5,5 L19.5,19.1 Z M19.5,3 L4.5,3 C3.4,3 2.5,3.9 2.5,5 L2.5,19 C2.5,20.1 3.4,21 4.5,21 L19.5,21 C20.6,21 21.5,20.1 21.5,19 L21.5,5 C21.5,3.9 20.6,3 19.5,3 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol